export default "__VITE_ASSET__D5IGkrg0__"